const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 88.277,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 335.45,
    rx: 38.345
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9933"
    },
    d: "M473.655,88.273H38.345C17.167,88.273,0,105.44,0,126.618v83.103h512v-83.103C512,105.44,494.833,88.273,473.655,88.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#128807"
    },
    d: "M0,385.377c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345v-83.103H0V385.377z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 256,
    cy: 255.997,
    r: 34.359
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 256,
    cy: 255.997,
    r: 27.586
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 256,
    cy: 228.411,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 256,
    cy: 283.583,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 283.586,
    cy: 255.997,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 228.414,
    cy: 255.997,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 275.502,
    cy: 236.495,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 236.498,
    cy: 275.499,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 275.502,
    cy: 275.499,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 236.498,
    cy: 236.495,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 266.248,
    cy: 230.769,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 245.752,
    cy: 281.225,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 281.228,
    cy: 266.245,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 230.772,
    cy: 245.749,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 281.228,
    cy: 245.749,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 230.772,
    cy: 266.245,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 266.248,
    cy: 281.225,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 245.752,
    cy: 230.769,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 270.972,
    cy: 233.023,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 241.028,
    cy: 278.971,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 278.974,
    cy: 270.969,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 233.026,
    cy: 241.025,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 278.974,
    cy: 241.025,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 233.026,
    cy: 270.969,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 270.972,
    cy: 278.971,
    r: 3.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000080"
    },
    cx: 241.028,
    cy: 233.023,
    r: 3.448
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.8215f8a85d4e127609bfee06778e942f.svg";
export { ForwardRef as ReactComponent };